// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__2ZZst","color-change-2x":"Skeleton_color-change-2x__Nuaml","center":"Skeleton_center__11IAg"};